/**
 * 🔗 [Phase v13.60.11 — 2026-08-15] Helpers de formatage pour le sélecteur
 *   de Bon de Travail (KioskScanMode). Fichier PUR (sans JSX ni React) →
 *   permet l'import direct depuis les tests Jest.
 *
 * Compatibilité :
 *   - Import ES6 depuis le composant React : `import { … } from '@/lib/kioskBTFormat';`
 *   - Import CommonJS depuis les tests Jest : `const { … } = require('../lib/kioskBTFormat');`
 *   (double export CJS + ES6 comme /lib/formatItemHoraire.js).
 */

/**
 * Formatte l'adresse de chantier d'un BT en version COMPACTE sur 1 ligne.
 *
 * Exemples :
 *   { adresse_travaux: '123 rue Principale', ville_travaux: 'Québec' }
 *     → "123 rue Principale, Québec"
 *   { adresse_travaux: '456 boul. Laurier', ville_travaux: '' }
 *     → "456 boul. Laurier"
 *   { adresse_travaux: '', ville_travaux: 'Lévis' }
 *     → "Lévis"
 *   { adresse_travaux: '', ville_travaux: '' }
 *     → ""
 *
 * @param {{ adresse_travaux?: string, ville_travaux?: string }} bt
 * @returns {string}
 */
function formatAdresseCompacte(bt) {
  if (!bt) return '';
  const adr = String(bt.adresse_travaux || '').trim();
  const ville = String(bt.ville_travaux || '').trim();
  if (adr && ville) return `${adr}, ${ville}`;
  return adr || ville || '';
}

/**
 * Construit le label enrichi affiché après sélection d'un BT dans le
 * sélecteur (mode scan Sortie). Format : « Client · Nom du BT · Adresse ».
 *
 * 🔠 [Phase v13.60.11.1 — 2026-08-15] Le nom textuel du BT (champ
 *   `nom_bt`, alias de `description_travaux` en DB) remplace le numéro BT
 *   dans l'affichage. Le numéro reste disponible en DB pour les
 *   opérations backend, mais l'utilisatrice ne veut PAS le voir dans
 *   l'entrepôt.
 *
 * Fallback : si `nom_bt` est vide (majorité des BT hérités), on n'affiche
 *   PAS de placeholder — on affiche juste « Client · Adresse ».
 *
 * @param {{ client_nom?: string, nom_bt?: string, numero_bt?: string, numero?: string,
 *           adresse_travaux?: string, ville_travaux?: string,
 *           nom_dossier?: string, id?: string }} bt
 * @returns {string}
 */
function buildLiaisonLabel(bt) {
  if (!bt) return '';
  const parts = [];
  if (bt.client_nom) parts.push(bt.client_nom);
  const nomBT = String(bt.nom_bt || '').trim();
  if (nomBT) parts.push(nomBT);
  const adr = formatAdresseCompacte(bt);
  if (adr) parts.push(adr);
  return parts.join(' · ') || bt.nom_dossier || bt.id || '';
}

module.exports = {
  formatAdresseCompacte,
  buildLiaisonLabel,
};
// ES6 default export pour compat React/Babel
module.exports.default = { formatAdresseCompacte, buildLiaisonLabel };
